import { z } from "zod";

/** POST /v1/tasks/:id/dispute — K-047: tamamlandıktan sonra dispute_window_hours (72) içinde sorun bildirimi */
export const OpenDisputeBody = z.object({
  reason: z.enum(["not_done", "poor_quality", "overcharged", "damage", "no_show", "other"]),
  description: z.string().trim().min(10).max(2000),
  /** kanıt: task-media kovasına yüklenmiş, bu işe ait dosyalar (K-052) */
  evidencePaths: z
    .array(z.string().regex(/^[0-9a-f-]{36}\/[A-Za-z0-9._-]{1,200}$/))
    .max(10)
    .default([]),
});

/** POST /v1/admin/disputes/:id/resolve — destek kararı */
export const ResolveDisputeBody = z
  .object({
    resolution: z.enum(["no_refund", "partial_refund", "full_refund"]),
    refundMinor: z
      .string()
      .regex(/^\d{1,9}$/)
      .optional(),
    note: z.string().trim().min(3).max(1000),
  })
  .refine((b) => b.resolution !== "partial_refund" || b.refundMinor !== undefined, {
    message: "kısmi iadede tutar gerekli",
    path: ["refundMinor"],
  });
export type ResolveDisputeBody = z.infer<typeof ResolveDisputeBody>;
